var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 0H1.71429C0.767857 0 0 0.767857 0 1.71429V14.2857C0 15.2321 0.767857 16 1.71429 16H14.2857C15.2321 16 16 15.2321 16 14.2857V1.71429C16 0.767857 15.2321 0 14.2857 0ZM12.5393 5.67143C12.5464 5.77143 12.5464 5.875 12.5464 5.975C12.5464 9.07143 10.1893 12.6393 5.88214 12.6393C4.55357 12.6393 3.32143 12.2536 2.28571 11.5893C2.475 11.6107 2.65714 11.6179 2.85 11.6179C3.94643 11.6179 4.95357 11.2464 5.75714 10.6179C4.72857 10.5964 3.86429 9.92143 3.56786 8.99286C3.92857 9.04643 4.25357 9.04643 4.625 8.95C3.55357 8.73214 2.75 7.78929 2.75 6.65V6.62143C3.06071 6.79643 3.425 6.90357 3.80714 6.91786C3.48587 6.70415 3.22249 6.41424 3.04053 6.07398C2.85856 5.73373 2.76365 5.35372 2.76429 4.96786C2.76429 4.53214 2.87857 4.13214 3.08214 3.78571C4.23571 5.20714 5.96786 6.13572 7.91071 6.23571C7.57857 4.64643 8.76786 3.35714 10.1964 3.35714C10.8714 3.35714 11.4786 3.63929 11.9071 4.09643C12.4357 3.99643 12.9429 3.8 13.3929 3.53214C13.2179 4.075 12.85 4.53214 12.3643 4.82143C12.8357 4.77143 13.2929 4.63929 13.7143 4.45714C13.3964 4.925 12.9964 5.33929 12.5393 5.67143Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.b36e3e999e11f35f5108fe1f8252c6dc.svg";
export { ForwardRef as ReactComponent };